﻿export class LastViewedArticleDto
{
    articleID;
    productID;
    productName;

    constructor(data)
    {
        if (data)
        {
            this.articleID = data.articleID;
            this.productID = data.productID;
            this.productName = data.productName;
        }
    }
};